import React from 'react';
import type { Nullable, SignupFlow } from 'corgi-types';

import DynamicForm from 'common/components/DynamicForm';
import FormSubmitButton from 'common/components/Form/FormSubmitButton';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { FieldName } from '../enums';
import { useFormGroups } from '../hooks/form-groups';
import { usePerformLoginHandler } from '../hooks/perform-login';
import ForgotPasswordLink from './ForgotPasswordLink';

interface PasswordFormProps {
  setCommonError: (errorMessage: Nullable<string>) => void;
  onSuccess: () => void;
  userFlow: SignupFlow;
  email: string;
}

const PasswordForm = ({ setCommonError, onSuccess, userFlow, email }: PasswordFormProps) => {
  const { t } = useLocalization();

  const formGroups = useFormGroups({
    withEmailField: false,
    withForgotPasswordLink: false,
    userFlow,
  });
  const { isSuccessful, performLoginHandler } = usePerformLoginHandler({
    setCommonError,
    onSuccess,
  });
  const onSubmit = async (fieldValues: { [Key in FieldName]: string }) => {
    await performLoginHandler({ ...fieldValues, emailAddress: email });
  };

  return (
    <>
      <DynamicForm
        id="login-password-form"
        aria-label={t('h24_login_form')}
        formGroups={formGroups}
        formConfig={{
          criteriaMode: 'all',
        }}
        onSubmit={onSubmit}
        renderSubmitButton={props => (
          <FormSubmitButton
            {...props}
            isSuccess={isSuccessful}
            defaultButtonLabel={t('h24_login_form_submit_btn')}
            successButtonLabel={t('h24_login_with_success')}
            mb="sp_12"
          />
        )}
      />
      <ForgotPasswordLink userFlow={userFlow} />
    </>
  );
};

export default PasswordForm;
